import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardAlertInfo } from "../../../../../../shared/components/alert/StandardAlertInfo"
import { FormikDatePicker } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { SupplierFormValues } from "../../supplier/supplierTypes"

const useStyles = makeStyles()(() => ({
    field: {
        width: "50%",
    },
}))

export function SubscriptionDetailsContent() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="support-create-entity-subscription-details-subtitle">
                <Typography mb="0.5rem" fontWeight={400}>
                    Subscription details
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict
                id="support-create-entity-subscription-details-field-implementationDeadline"
                attrs={{ label: true }}
            >
                <FormikDatePicker<SupplierFormValues, unknown>
                    name="implementationDeadline"
                    range="all"
                    label="Deadline for implementation *"
                    className={classes.field}
                />
            </LocalizedStrict>

            <LocalizedStrict id="support-create-entity-subscription-details-alert-title" attrs={{ title: true }}>
                <StandardAlertInfo title="This is the date by which the customer wants the system to go into production. This means onboarding, internal testing and any trial period must be completed before this date." />
            </LocalizedStrict>
        </>
    )
}

